import { AboutContainer, Hero, Content, Team, TeamMember, Values, ValueCard } from './styles';
import { FaHandshake, FaBalanceScale, FaUsers, FaGlobe, FaGavel, FaLeaf, FaHeart, FaEquals, FaUserShield } from 'react-icons/fa';

const About = () => {
  const values = [
    {
      icon: <FaHandshake />,
      title: "Transparence",
      description: "Nous nous engageons à une gestion claire et responsable de nos actions"
    },
    {
      icon: <FaGavel />,
      title: "Objectivité",
      description: "Nous garantissons une approche impartiale et juste dans toutes nos actions"
    },
    {
      icon: <FaUserShield />,
      title: "Respect des Droits de l'Homme",
      description: "Nous défendons et promouvons les droits fondamentaux de chaque individu"
    },
    {
      icon: <FaGlobe />,
      title: "Développement",
      description: "Nous agissons pour un développement respectueux et pérenne"
    },
    {
      icon: <FaBalanceScale />,
      title: "indépendance morale et politique",
      description: "Nous garantissons une indépendance totale dans nos actions et décisions"
    },
    {
      icon: <FaUsers />,
      title: "Participation citoyenne",
      description: "Nous encourageons l'engagement et la participation active de tous les citoyens"
    },
    {
      icon: <FaHeart />,
      title: "Financement éthique",
      description: "Nous garantissons un financement transparent et responsable de nos actions"
    },
    {
      icon: <FaEquals />,
      title: "Non discrimination",
      description: "Nous garantissons l'égalité de traitement et l'absence de discrimination dans toutes nos actions"
    }, 
    {
      icon: <FaLeaf />,
      title: "Engagement responsable",
      description: "Nous nous engageons à un développement durable et respectueux de l'environnement"
    },
    {
      icon: <FaEquals />,
      title: "Egalité des chances",
      description: "Nous garantissons l'égalité des chances pour tous, sans distinction d'origine, de genre ou de statut."
    }
  ];

  return (
    <AboutContainer>
      <Hero>
        <h1>À Propos de nous</h1>
      </Hero>

      <Content>
        <div className="container">
          <h2>Notre Histoire</h2>
          <p>
            Le CODHOD est une organisation de la société civile congolaise créée le 23 mars 2003 et enregistré légalement le 07 mai 2005, sous le numéro F92/8384. La lutte contre la pauvreté et l’injustice sociale par la promotion des Droits de l’homme avec la participation populaire sont à la base de nos préoccupations.
          </p>
          <p>
            Notre stratégie d'intervention est centrée sur les recherches (monitoring), la formation, l'éducation, la mutualisation, l’harmonie sociale et le bien-être des populations locales.
          </p>
          <p>
            Notre vision est d'être la meilleure organisation de la société civile qui lie les actions de développement aux droits de l’Homme par l’accompagnement des acteurs et des citoyens à la base.
          </p>
          <p>
            Ainsi, nous nous sommes donnés pour mission d'accompagner les acteurs locaux, les entités territoriales décentralisées et les OCB dans les actions de développement basées sur le respect et la promotion des droits humains en luttant contre toute forme de discrimination liée au genre par le renforcement de leur capacité d'intervention et par des recherches de terrain dans les différents secteurs dont la santé, l’environnement, les finances publiques locales, spécialiste en genre, les droits humains, la justice etc..
          </p>
          <p>
            L’ONG CODHOD regorge une équipe pluridisciplinaire, composée des sociologues, philosophes, anthropologues, juristes, environnementalistes, informaticiens, psychologues et autres.
          </p>
        </div>
      </Content>

      <Values>
        <div className="container">
          <h2>Nos Valeurs</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <ValueCard key={index}>
                <div className="icon">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </ValueCard>
            ))}
          </div>
        </div>
      </Values>

      {/* <Team>
        <div className="container">
          <h2>Notre Équipe</h2>
          <div className="team-grid">
            <TeamMember>
              <img src="/images/team1.jpg" alt="Membre de l'équipe" />
              <h3>Jean Dupont</h3>
              <p>Directeur Général</p>
            </TeamMember>
            <TeamMember>
              <img src="/images/team2.jpg" alt="Membre de l'équipe" />
              <h3>Marie Martin</h3>
              <p>Coordinatrice des Programmes</p>
            </TeamMember>
            <TeamMember>
              <img src="/images/team3.jpg" alt="Membre de l'équipe" />
              <h3>Pierre Dubois</h3>
              <p>Responsable Communication</p>
            </TeamMember>
          </div>
        </div>
      </Team> */}
    </AboutContainer>
  );
};

export default About;